import React from 'react';
import PropTypes from 'prop-types';

import DatePresenter from '../../../presenters/DatePresenter';
import Card from '../../../components/Card';
import Group from '../../../components/Group';

const ReportData = (props) => {
  const { transactionsData, cashbacksData, startDate, endDate } = props;
  const { depositsAmount, expensesAmount } = transactionsData;

  const {
    netCashbacksAmount,
    earnedCashbacksAmount,
    refundCashbacksAmount,
    spentCashbacksAmount,
  } = cashbacksData;

  const tooltipContent = `Earned FastCash: $${earnedCashbacksAmount}
  Refund FastCash: $${refundCashbacksAmount}`;
  const americanShortStartDate =
    DatePresenter.americanShortFormattedDate(startDate);
  const americanShortEndDate =
    DatePresenter.americanShortFormattedDate(endDate);

  return (
    <Group
      title={`Reporting for period ${americanShortStartDate} - ${americanShortEndDate}`}
    >
      <div className="card-container">
        <Card title="Expenses" content={`$${expensesAmount}`} />
        <Card title="Deposits" content={`$${depositsAmount}`} />
        <Card
          title="Net Earned FastCash"
          content={`$${netCashbacksAmount}`}
          tooltipContent={tooltipContent}
        />
        <Card title="Spent FastCash" content={`$${spentCashbacksAmount}`} />
      </div>
    </Group>
  );
};

export default ReportData;

ReportData.propTypes = {
  transactionsData: PropTypes.shape(),
  cashbacksData: PropTypes.shape(),
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};
